import { FC } from 'react'
import styles from './styles.module.scss'
import { Link } from '../Link'
import Image from 'next/image'
import {
  facebookLogo,
  instagramLogo,
  linkedInLogo,
  tiktokLogo,
  twitterLogo,
} from '@/assets/social'

type PlatformName = 'twitter' | 'linkedin' | 'facebook' | 'instagram' | 'tiktok'

export interface FooterSocialLink {
  sys: {
    id: string
  }
  fields: {
    displayName: string
    platformName: PlatformName
    url: string
  }
}

interface SocialLinkProps {
  links: FooterSocialLink[]
}

export const SocialLinks: FC<SocialLinkProps> = ({ links }) => {
  const fetchImage = (platformName: PlatformName) => {
    const imageMap = {
      twitter: twitterLogo,
      linkedin: linkedInLogo,
      facebook: facebookLogo,
      instagram: instagramLogo,
      tiktok: tiktokLogo,
    }

    return imageMap[platformName]
  }

  return (
    <ul id="socialLinkList" className={styles.socialLinks}>
      {links.map((link: FooterSocialLink) => {
        return (
          <li key={link.sys.id}>
            <Link
              className={styles.link}
              newTab
              url={link.fields.url}
              title={link.fields.displayName}
            >
              <Image
                src={fetchImage(link.fields.platformName)}
                alt={link.fields.displayName}
              />
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
